module.exports = __webpack_public_path__ + "static/media/sponcer_PEGASUS.f0798ae0.png";